import React from 'react'
import { Modal, Button } from 'semantic-ui-react'

type SurveyQuestionVisibilityModalProps = {
  isOpen: boolean
  header: string
  content?: React.ReactNode
  buttonLabel: string
  size?: 'mini' | 'tiny' | 'small' | 'large' | 'fullscreen'
  onClose: () => void
  onButtonClick: () => void
}

const SurveyQuestionVisibilityModal: React.FC<SurveyQuestionVisibilityModalProps> = ({
  isOpen,
  header,
  content,
  buttonLabel,
  size = 'tiny',
  onClose,
  onButtonClick,
}) => (
  <Modal open={isOpen} size={size} onClose={onClose}>
    <Modal.Header>{header}</Modal.Header>
    {content ? <Modal.Content>{content}</Modal.Content> : null}
    <Modal.Actions>
      <Button content="Cancel" onClick={onClose} type="button" />
      <Button color="red" content={buttonLabel} onClick={onButtonClick} />
    </Modal.Actions>
  </Modal>
)

export default SurveyQuestionVisibilityModal



// WEBPACK FOOTER //
// ./src/organisms/SurveyQuestionVisibilityModal/index.tsx